import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { ChangePasswordComponent } from './change-password/change-password.component';

@Component({
  selector: 'app-account-settings-security',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NzCardModule,
    ChangePasswordComponent,
  ],
  templateUrl: './account-settings-security.component.html',
  styleUrl: './account-settings-security.component.less'
})
export class AccountSettingsSecurityComponent {}
